import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'list-item-view',
  templateUrl: './list-item-view.component.html',
  styleUrls: ['./list-item-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemViewComponent {
  @Input() itemTitle?: string;
  @Input() clickable = false;

  @Output() removeItem = new EventEmitter();
  @Output() onClick = new EventEmitter();

  selectItem() {
    if (this.clickable) {
      this.onClick.emit();
    }
  }

  onClickDeleteButton(event: MouseEvent) {
    event.stopPropagation();
    this.removeItem.emit();
  }
}
